const G = "", K = "";
let U = null;
function N() {
  return U || (U = (async () => {
    try {
      const m = new AbortController(), w = setTimeout(() => m.abort(), 2500), s = await fetch("https://api.country.is/", { signal: m.signal });
      clearTimeout(w);
      const f = await s.json();
      return f && f.country === "CN" ? "cn" : "os";
    } catch {
      return "os";
    }
  })(), U);
}
async function B(m) {
  return m || "/edge-" + await N();
}
const O = [{ urls: "stun:stun.l.google.com:19302" }];
function W(m) {
  function w(i, o) {
    return i << o | i >>> 32 - o;
  }
  function s(i, o) {
    const e = (i & 65535) + (o & 65535);
    return (i >> 16) + (o >> 16) + (e >> 16) << 16 | e & 65535;
  }
  function f(i, o, e, t, n, r) {
    return s(w(s(s(o, i), s(t, r)), n), e);
  }
  function h(i, o, e, t, n, r, c) {
    return f(o & e | ~o & t, i, o, n, r, c);
  }
  function g(i, o, e, t, n, r, c) {
    return f(o & t | e & ~t, i, o, n, r, c);
  }
  function y(i, o, e, t, n, r, c) {
    return f(o ^ e ^ t, i, o, n, r, c);
  }
  function p(i, o, e, t, n, r, c) {
    return f(e ^ (o | ~t), i, o, n, r, c);
  }
  function F(i) {
    const o = [];
    for (let e = 0; e < i.length * 8; e += 8) o[e >> 5] |= (i.charCodeAt(e / 8) & 255) << e % 32;
    return o;
  }
  function k(i) {
    const o = "0123456789abcdef";
    let e = "";
    for (let t = 0; t < i.length * 4; t++) {
      const n = i[t >> 2] >> t % 4 * 8 & 255;
      e += o.charAt(n >> 4 & 15) + o.charAt(n & 15);
    }
    return e;
  }
  function D(i, o) {
    i[o >> 5] |= 128 << o % 32, i[(o + 64 >>> 9 << 4) + 14] = o;
    let e = 1732584193, t = -271733879, n = -1732584194, r = 271733878;
    for (let c = 0; c < i.length; c += 16) {
      const $ = e, I = t, A = n, M = r;
      e = h(e, t, n, r, i[c], 7, -680876936), r = h(r, e, t, n, i[c + 1], 12, -389564586), n = h(n, r, e, t, i[c + 2], 17, 606105819), t = h(t, n, r, e, i[c + 3], 22, -1044525330), e = h(e, t, n, r, i[c + 4], 7, -176418897), r = h(r, e, t, n, i[c + 5], 12, 1200080426), n = h(n, r, e, t, i[c + 6], 17, -1473231341), t = h(t, n, r, e, i[c + 7], 22, -45705983), e = h(e, t, n, r, i[c + 8], 7, 1770035416), r = h(r, e, t, n, i[c + 9], 12, -1958414417), n = h(n, r, e, t, i[c + 10], 17, -42063), t = h(t, n, r, e, i[c + 11], 22, -1990404162), e = h(e, t, n, r, i[c + 12], 7, 1804603682), r = h(r, e, t, n, i[c + 13], 12, -40341101), n = h(n, r, e, t, i[c + 14], 17, -1502002290), t = h(t, n, r, e, i[c + 15], 22, 1236535329), e = g(e, t, n, r, i[c + 1], 5, -165796510), r = g(r, e, t, n, i[c + 6], 9, -1069501632), n = g(n, r, e, t, i[c + 11], 14, 643717713), t = g(t, n, r, e, i[c], 20, -373897302), e = g(e, t, n, r, i[c + 5], 5, -701558691), r = g(r, e, t, n, i[c + 10], 9, 38016083), n = g(n, r, e, t, i[c + 15], 14, -660478335), t = g(t, n, r, e, i[c + 4], 20, -405537848), e = g(e, t, n, r, i[c + 9], 5, 568446438), r = g(r, e, t, n, i[c + 14], 9, -1019803690), n = g(n, r, e, t, i[c + 3], 14, -187363961), t = g(t, n, r, e, i[c + 8], 20, 1163531501), e = g(e, t, n, r, i[c + 13], 5, -1444681467), r = g(r, e, t, n, i[c + 2], 9, -51403784), n = g(n, r, e, t, i[c + 7], 14, 1735328473), t = g(t, n, r, e, i[c + 12], 20, -1926607734), e = y(e, t, n, r, i[c + 5], 4, -378558), r = y(r, e, t, n, i[c + 8], 11, -2022574463), n = y(n, r, e, t, i[c + 11], 16, 1839030562), t = y(t, n, r, e, i[c + 14], 23, -35309556), e = y(e, t, n, r, i[c + 1], 4, -1530992060), r = y(r, e, t, n, i[c + 4], 11, 1272893353), n = y(n, r, e, t, i[c + 7], 16, -155497632), t = y(t, n, r, e, i[c + 10], 23, -1094730640), e = y(e, t, n, r, i[c + 13], 4, 681279174), r = y(r, e, t, n, i[c], 11, -358537222), n = y(n, r, e, t, i[c + 3], 16, -722521979), t = y(t, n, r, e, i[c + 6], 23, 76029189), e = y(e, t, n, r, i[c + 9], 4, -640364487), r = y(r, e, t, n, i[c + 12], 11, -421815835), n = y(n, r, e, t, i[c + 15], 16, 530742520), t = y(t, n, r, e, i[c + 2], 23, -995338651), e = p(e, t, n, r, i[c], 6, -198630844), r = p(r, e, t, n, i[c + 7], 10, 1126891415), n = p(n, r, e, t, i[c + 14], 15, -1416354905), t = p(t, n, r, e, i[c + 5], 21, -57434055), e = p(e, t, n, r, i[c + 12], 6, 1700485571), r = p(r, e, t, n, i[c + 3], 10, -1894986606), n = p(n, r, e, t, i[c + 10], 15, -1051523), t = p(t, n, r, e, i[c + 1], 21, -2054922799), e = p(e, t, n, r, i[c + 8], 6, 1873313359), r = p(r, e, t, n, i[c + 15], 10, -30611744), n = p(n, r, e, t, i[c + 6], 15, -1560198380), t = p(t, n, r, e, i[c + 13], 21, 1309151649), e = p(e, t, n, r, i[c + 4], 6, -145523070), r = p(r, e, t, n, i[c + 11], 10, -1120210379), n = p(n, r, e, t, i[c + 2], 15, 718787259), t = p(t, n, r, e, i[c + 9], 21, -343485551), e = s(e, $), t = s(t, I), n = s(n, A), r = s(r, M);
    }
    return [e, t, n, r];
  }
  const L = unescape(encodeURIComponent(m));
  return k(D(F(L), L.length * 8));
}
const q = "OJ4rnZIOAymtYDaX", V = "5ql1dd7tVPRjoXdt", X = 24 * 3600;
function H(m, w) {
  const s = String(Math.floor(Date.now() / 1e3) + X);
  return { t: s, token: W(`${m}${s}${w}`) };
}
function j(m, w, s, f, h, g) {
  let y = `${m}/${w}/${encodeURIComponent(s)}/${encodeURIComponent(f)}`;
  const p = [];
  return h && p.push(`t=${encodeURIComponent(h)}`), g && p.push(`token=${encodeURIComponent(g)}`), p.length && (y += `?${p.join("&")}`), y;
}
class b {
  constructor() {
    this._m = /* @__PURE__ */ new Map();
  }
  on(w, s) {
    return this._m.has(w) || this._m.set(w, /* @__PURE__ */ new Set()), this._m.get(w).add(s), () => this.off(w, s);
  }
  off(w, s) {
    const f = this._m.get(w);
    f && f.delete(s);
  }
  emit(w, s) {
    const f = this._m.get(w);
    f && f.forEach((h) => {
      try {
        h(s);
      } catch {
      }
    });
  }
}
function J() {
  const m = new b();
  let w = null, s = null, f = null, h = new MediaStream(), g = null, y = !1, p = null, F = null;
  async function k(a, l, v) {
    const u = {
      method: "POST",
      headers: { "Content-Type": "application/sdp" },
      body: l
    }, d = v ? await e(a, u, v) : await fetch(a, u);
    if (!d.ok) {
      const T = await d.text().catch(() => "");
      throw new Error(`信令请求失败: ${d.status} ${d.statusText} ${T ? "- " + T.slice(0, 160) : ""}`);
    }
    const S = await d.text();
    if (!S || !S.includes("v=")) throw new Error("信令响应无有效 SDP");
    let E = null;
    const C = d.headers.get("Location");
    if (C)
      try {
        E = new URL(C, typeof location < "u" ? location.href : a).href;
      } catch {
        E = C;
      }
    return { answerSdp: S, resourceUrl: E };
  }
  function D(a) {
    const l = typeof RTCRtpSender < "u" ? RTCRtpSender : null;
    if (!l || !l.getCapabilities) return;
    const v = l.getCapabilities("video");
    if (!v || !v.codecs) return;
    const u = v.codecs.filter((d) => /\/(H264|rtx|red|ulpfec)$/i.test(d.mimeType));
    u.length && a.getTransceivers().forEach((d) => {
      if ((d.receiver && d.receiver.track && d.receiver.track.kind || d.sender && d.sender.track && d.sender.track.kind) === "video" && d.setCodecPreferences)
        try {
          d.setCodecPreferences(u);
        } catch {
        }
    });
  }
  function L(a, l = 3e3) {
    return a.iceGatheringState === "complete" ? Promise.resolve() : new Promise((v) => {
      const u = () => {
        C(), v();
      }, d = () => {
        a.iceGatheringState === "complete" && u();
      }, S = (T) => {
        T.candidate || u();
      }, E = setTimeout(u, l);
      function C() {
        clearTimeout(E), a.removeEventListener("icegatheringstatechange", d), a.removeEventListener("icecandidate", S);
      }
      a.addEventListener("icegatheringstatechange", d), a.addEventListener("icecandidate", S);
    });
  }
  async function i(a) {
    if (a)
      try {
        await e(a, { method: "DELETE" }, 4e3), o("已 DELETE 资源: " + a);
      } catch (l) {
        o("DELETE 资源失败(忽略): " + ((l == null ? void 0 : l.message) || l));
      }
  }
  const o = (a) => m.emit("log", a), e = async (a, l = {}, v = 8e3) => {
    const u = new AbortController(), d = setTimeout(() => u.abort(), v);
    try {
      return await fetch(a, { ...l, signal: u.signal });
    } finally {
      clearTimeout(d);
    }
  };
  async function t() {
    await navigator.mediaDevices.getUserMedia({ video: !0, audio: !0 }).catch(() => {
    });
    const a = await navigator.mediaDevices.enumerateDevices();
    return {
      cameras: a.filter((l) => l.kind === "videoinput"),
      mics: a.filter((l) => l.kind === "audioinput")
    };
  }
  function n(a) {
    a && a.getTracks().forEach((l) => {
      try {
        l.stop();
      } catch {
      }
    });
  }
  async function r({ videoDeviceId: a, audioDeviceId: l } = {}) {
    c();
    const v = {
      video: a ? { deviceId: { exact: a } } : !0,
      audio: l ? { deviceId: { exact: l } } : !0
    };
    try {
      w = await navigator.mediaDevices.getUserMedia(v);
    } catch (u) {
      if ((a || l) && ((u == null ? void 0 : u.name) === "OverconstrainedError" || /constraint/i.test((u == null ? void 0 : u.message) || "")))
        o("指定设备不可用(" + ((u == null ? void 0 : u.name) || (u == null ? void 0 : u.message)) + ")，回退默认设备"), w = await navigator.mediaDevices.getUserMedia({ video: !0, audio: !0 });
      else
        throw u;
    }
    return m.emit("preview-stream", w), o("本地预览已开启"), w;
  }
  function c() {
    n(w), w = null, m.emit("preview-stopped");
  }
  async function $({
    app: a,
    stream: l,
    base: v = G,
    t: u,
    token: d
  }) {
    if (!a || !l) throw new Error("缺少推流参数 app/stream");
    if (v = await B(v), o("推流节点区域: " + v), !d) {
      const P = H(l, q);
      u = P.t, d = P.token;
    }
    if (!w && (await r(), !w))
      throw new Error("无法获取本地媒体流");
    if (s)
      try {
        s.close();
      } catch {
      }
    g = { app: a, stream: l, base: v, t: u, token: d, playBase: K }, s = new RTCPeerConnection({ iceServers: O }), w.getTracks().forEach((P) => s.addTransceiver(P, { direction: "sendonly", streams: [w] })), D(s), s.oniceconnectionstatechange = () => {
      o("推流 ICE 状态: " + s.iceConnectionState), m.emit("push-ice", s.iceConnectionState);
    };
    const S = await s.createOffer();
    await s.setLocalDescription(S), await L(s);
    const E = s.localDescription.sdp, C = j(v, "whip", a, l, u, d);
    o("推流信令(WHIP): " + C), o("推流 offer 就绪，候选数: " + (E.match(/a=candidate:/g) || []).length);
    const { answerSdp: T, resourceUrl: _ } = await k(C, E);
    return p = _, o("推流 answer 收到，SDP 长度: " + T.length + (_ ? "，资源: " + _ : "，无 Location(跨域未暴露?)")), o("answer 候选: " + (T.match(/a=candidate:.*|c=IN.*/g) || []).join(" | ")), await s.setRemoteDescription({ type: "answer", sdp: T }), o("推流成功"), m.emit("push-success", { app: a, stream: l, base: v, t: u, token: d, playBase: g.playBase }), { app: a, stream: l, base: v, t: u, token: d };
  }
  async function I() {
    if (s) {
      try {
        s.close();
      } catch {
      }
      s = null;
    }
    const a = p;
    p = null, await i(a), o("推流已停止"), m.emit("push-stopped");
  }
  async function A({
    app: a,
    stream: l,
    base: v,
    t: u,
    token: d
  }) {
    if (!a || !l) throw new Error("缺少拉流参数 app/stream");
    const S = await B(v);
    if (o("拉流节点区域: " + S), !d) {
      const E = H(l, V);
      u = E.t, d = E.token;
    }
    if (y) {
      o("拉流启动中，跳过本次触发");
      return;
    }
    y = !0;
    try {
      if (f) {
        try {
          f.close();
        } catch {
        }
        f = null;
      }
      f = new RTCPeerConnection({ iceServers: O }), h = new MediaStream();
      try {
        f.addTransceiver("video", { direction: "recvonly" });
      } catch (R) {
        o("添加 video transceiver 失败: " + R.message);
      }
      try {
        f.addTransceiver("audio", { direction: "recvonly" });
      } catch (R) {
        o("添加 audio transceiver 失败: " + R.message);
      }
      D(f), f.ontrack = (R) => {
        R.streams[0].getTracks().forEach((Y) => h.addTrack(Y)), m.emit("play-stream", h), o("收到远端 track: " + R.track.kind);
      }, f.oniceconnectionstatechange = () => {
        o("拉流 ICE 状态: " + f.iceConnectionState), m.emit("play-ice", f.iceConnectionState);
      };
      const E = await f.createOffer();
      await f.setLocalDescription(E), await L(f);
      const C = f.localDescription.sdp, T = j(S, "whep", a, l, u, d);
      o("拉流信令(WHEP): " + T), o("拉流 offer 就绪，候选数: " + (C.match(/a=candidate:/g) || []).length);
      const { answerSdp: _, resourceUrl: P } = await k(T, C, 8e3);
      return F = P, o("拉流 answer 收到，SDP 长度: " + _.length + (P ? "，资源: " + P : "，无 Location(跨域未暴露?)")), await f.setRemoteDescription({ type: "answer", sdp: _ }), o("拉流已建立"), m.emit("play-success", { app: a, stream: l, base: S, t: u, token: d }), { app: a, stream: l, base: S, t: u, token: d };
    } finally {
      y = !1;
    }
  }
  async function M() {
    if (f) {
      try {
        f.close();
      } catch {
      }
      f = null;
    }
    const a = F;
    F = null, await i(a), h && (n(h), h = new MediaStream(), m.emit("play-stream", h)), o("拉流已停止"), m.emit("play-stopped");
  }
  return {
    on: (...a) => m.on(...a),
    off: (...a) => m.off(...a),
    getDevices: t,
    startPreview: r,
    stopPreview: c,
    startPush: $,
    stopPush: I,
    startPlay: A,
    stopPlay: M
  };
}
export {
  J as CreateSellyRtcEngine
};
//# sourceMappingURL=sellycloudwebsdk.es.js.map
